import { Typography } from '@mui/material';
import { BoxedUrlWithCopy } from 'components';
import { SINGLE_SIGN_ON_TEST_IDS } from '../../SingleSignOn.testIds';

const ServiceProviderInformation = ({ acsUrl, spEntityId }: { acsUrl: string; spEntityId: string }) => (
  <>
    <Typography variant="h3" data-testid={SINGLE_SIGN_ON_TEST_IDS.serviceProviderMetadataSection}> Service Provider Metadata</Typography>
    <Typography variant="body2">
      Use this information to configure your identity provider to enable Single Sign-On (SSO) for your firm.
    </Typography>
    <Typography variant="h4" mt={2} gutterBottom>
      Assertion Consumer Service (ACS) URL
    </Typography>
    <BoxedUrlWithCopy url={acsUrl} urlTestId={SINGLE_SIGN_ON_TEST_IDS.acsUrlValue} copyButtonTestId={SINGLE_SIGN_ON_TEST_IDS.acsUrlCopyAction} />
    <Typography variant="h4" mt={2} gutterBottom>
      Service Provider Entity ID
    </Typography>
    <BoxedUrlWithCopy url={spEntityId} urlTestId={SINGLE_SIGN_ON_TEST_IDS.entityIdValue} copyButtonTestId={SINGLE_SIGN_ON_TEST_IDS.entityIdCopyAction} />
  </>
);

export default ServiceProviderInformation;
